var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "178",
        height: "136",
        viewBox: "0 0 178 136",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: { d: "M177.149 0H0V136H177.149V0Z", fill: "#FFDC5F" },
      }),
      _c("path", {
        attrs: {
          d: "M0 135.988C0 98.433 39.656 67.9885 88.5742 67.9885H177.149V135.988H0Z",
          fill: "#FF9110",
        },
      }),
      _c("path", {
        attrs: {
          d: "M0 0C0 37.5555 39.656 68.0003 88.5742 68.0003H177.149V0H0Z",
          fill: "#FFC040",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }